import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { GetNetworksResponseDto } from '../../types';
import { apiClient } from '../apiClient';
import { createQueryConfig } from '../config';

export function useGetNetworks(): UseQueryResult<GetNetworksResponseDto> {
  return useQuery({
    queryKey: ['networks'],
    queryFn: async () => {
      const { data } = await apiClient.get('/v1/networks');
      return data;
    },
    ...createQueryConfig(1000 * 60 * 60),
  });
}
